
import {
  computed, defineComponent, ref, Ref,
} from 'vue';
import { useRoute } from 'vue-router';
import {
  IFileUpload,
  IGroupCoverPhotoUpload, IImageCrop, IPhoto,
} from '@/types/interfaces';
// import AppCropper from '@/components/AppCropper.vue';
import AppLoader from '@/components/UI/AppLoader.vue';
import SpacesService from '@/modules/spaces/services/SpacesService';
import UseUpload from '@/composables/UseUpload';
import UploadService from '@/services/UploadService';
import AppUploadInfo from '@/components/UI/AppUploadInfo.vue';
import AppTakePhoto from '@/components/AppTakePhoto.vue';
import { UPLOAD_PLACES } from '@/types/enums';

export default defineComponent({
  components: {
    // AppCropper,
    AppLoader,
    AppUploadInfo,
    AppTakePhoto,
  },
  props: {
    groupCover: { type: String, default: '' },
    isEditing: { type: Boolean, default: false },
  },
  setup(props, context) {
    const inputKey = ref(0);
    const imageToCrop = ref({} as IImageCrop);
    const route = useRoute();

    const isUploading = ref(false);

    const { uploadInfo, onUploadUpdate } = UseUpload();

    const loaderText = computed(
      () => '',
    );

    const fileInput: Ref<HTMLInputElement | null> = ref(null);

    function handleInput(event: Event) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const img: File = (event.target as HTMLInputElement).files![0];
      const payload = {
        url: URL.createObjectURL(img),
        fileName: img.name,
        fileType: img.type,
      };

      imageToCrop.value = payload;
      inputKey.value += 1;

      fileInput.value!.value = '';
    }

    function handleCroppedImage(fileUpload: {file: IFileUpload[]}) {
      imageToCrop.value = {} as IImageCrop;

      UploadService.batchUploadTUS(fileUpload.file, onUploadUpdate, { location: UPLOAD_PLACES.PHOTO }, undefined, [], true)
        .then((response) => {
          const res = response[0];
          const photo: IPhoto = {
            id: res.id,
            url: res.fileUrl,
          };
          const payload: IGroupCoverPhotoUpload = { photo, id: route.params.id as string };
          return SpacesService.saveGroupCoverPhoto(payload);
        })
        .then((response) => {
          if (response.success) {
            const cover: IPhoto = response.results.data.photo;
            context.emit('update-cover-photo', cover);
          }
        });
    }

    function cancelUpload() {
      UploadService.isAbortUpload = true;
      isUploading.value = false;
    }

    return {
      inputKey,
      imageToCrop,
      fileInput,
      loaderText,
      isUploading,
      uploadInfo,
      cancelUpload,
      handleInput,
      handleCroppedImage,
    };
  },
});
